import { render, staticRenderFns } from "./DialogUser.vue?vue&type=template&id=0d4cbdf6&scoped=true"
import script from "./DialogUser.vue?vue&type=script&lang=js"
export * from "./DialogUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4cbdf6",
  null
  
)

export default component.exports